import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-questant-redirect',
  templateUrl: './questant-redirect.component.html',
  styleUrls: ['./questant-redirect.component.css']
})
export class QuestantRedirectComponent implements OnInit {

  errorMessage: String;

  constructor(
    private _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(
      params => {
        const notificationId = Number(params.notificationId);
        if (notificationId) {
          // アプリお知らせ詳細画面のDeepLink生成
          const appDeepLink = `ainztulpeapp://notificationDetail/q_${notificationId}/NotificationListScreen`;
          // アプリホーム画面へ遷移
          window.location.href = appDeepLink;
        } else {
          // notificationIdが取得出来なかった場合
          this.errorMessage = '失敗';
          console.log('can not get notificationId');
        }

      }
    );
  }

}
